export default __webpack_public_path__ + "static/media/english-card.af44296c.webp";